// Locate the consultation-fee item for a department in a hospital price list.
// Exact names "General Doctor - Consultation" / "Specialist Doctor - Consultation" win; otherwise fall back to a fuzzy match.
const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z]+/g, ' ').trim();
const isConsult = (i) => /consult/i.test(i.item_name);

export const FEE_LABELS = { general: 'General Doctor - Consultation', specialist: 'Specialist Doctor - Consultation' };

export const findFeeItem = (priceList, dept) => {
  const list = priceList || [];
  if (dept === 'specialist') {
    return list.find((i) => norm(i.item_name) === 'specialist doctor consultation')
      || list.find((i) => isConsult(i) && /specialist/i.test(i.item_name))
      || null;
  }
  if (dept === 'general') {
    return list.find((i) => norm(i.item_name) === 'general doctor consultation')
      || list.find((i) => isConsult(i) && /general/i.test(i.item_name))
      || list.find((i) => isConsult(i) && !/specialist|follow|dental|gyn|antenatal|review/i.test(i.item_name))
      || null;
  }
  return null;
};
